import { IsArray, IsInt, IsNumber, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';

import { TaxonomyValues } from '../../taxonomy';
import { NomenclatureUnitCompositionRequest } from '../nomenclature-unit-composition.request';

export class NomenclaturePositionSumRequest {
    @IsOptional()
    @IsInt()
    public orderId?: number;

    @IsString()
    public nomPositionUuid: string;

    @IsOptional()
    @IsInt()
    public qty?: number;

    @IsOptional()
    @IsObject()
    public values?: TaxonomyValues;

    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    public composition?: NomenclatureUnitCompositionRequest[];

    @IsOptional()
    @IsNumber()
    public contrId?: number;

    constructor(data?: Partial<NomenclaturePositionSumRequest>) {
        this.orderId = data?.orderId;
        this.nomPositionUuid = data?.nomPositionUuid;
        this.qty = data?.qty;
        this.values = data?.values;
        this.composition = Array.isArray(data?.composition)
            ? data.composition.map(item => new NomenclatureUnitCompositionRequest(item))
            : data?.composition;
        this.contrId = data?.contrId;
    }
}
